import MainRoutes from './routes/routes';

function App() {
    return (
        <div className="App">
            <MainRoutes />
        </div>
    );
}

export default App;
